import React from 'react'
import { useSelector } from 'react-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { toast } from 'react-toastify'
import { Check } from '../../components/ToastContent'

export const ClearAllDataModal = (props) => {
    const [open, setOpen] = React.useState(false)
    const token = useSelector(
        (state) => state.auth.user.stsTokenManager.accessToken
    )

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = (answer) => {
        if (answer === 'yes') {
            props.deleteAllActivityHistory(token).then(() => {
                toast.success(
                    <Check text="All activity history has been deleted" />
                )
            })
        }
        setOpen(false)
    }

    return (
        <div>
            <div
                style={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingRight: '10px',
                }}
            >
                <Button
                    size="small"
                    color="secondary"
                    variant="outlined"
                    onClick={handleClickOpen}
                >
                    Clear activity history
                </Button>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <span role="img" aria-label="Warning">
                        ⚠️
                    </span>{' '}
                    {'Clear all data?'}{' '}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <strong>This is serious!</strong> This will delete all
                        activities registered on all users. This <i>cannot</i>{' '}
                        be undone. Are you sure this is what you want?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => handleClose('yes')}
                        color="secondary"
                        autoFocus
                    >
                        Yes
                    </Button>
                    <Button onClick={handleClose} color="white">
                        No, cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
